import { ToastProvider } from '@carvana/showroom-toast';
import SearchIcon from '~/icons/Search';
import { useShowSaveSearchNudge } from './hooks';
import { Content, TextWrapper } from './SaveSearchNudge.styles';
import SaveSearchNudgeForm from './SaveSearchNudgeForm';
import SaveSearchNudgeModal from './SaveSearchNudgeModal';

export default function SaveSearchNudge() {
  useShowSaveSearchNudge();

  return (
    <ToastProvider
      render={({ showToast }) => (
        <SaveSearchNudgeModal>
          <Content>
            <TextWrapper>
              <SearchIcon className="text-blue-4" />

              <p className="grid gap-8 text-blue-4 tl-header-s">
                Looking for something specific?
              </p>

              <p className="col-span-2 tl-header-m">
                Get notified when vehicle matches arrive
              </p>
            </TextWrapper>

            <SaveSearchNudgeForm showToast={showToast} />

            <p className="text-grey-5 tl-body-xs">
              This will subscribe you to Carvana emails even if you’ve
              previously unsubscribed.
            </p>
          </Content>
        </SaveSearchNudgeModal>
      )}
    />
  );
}
